import { useEffect } from 'react';

import { useRouteActions } from '@confluence/route-manager';
import { useBooleanFeatureFlag } from '@confluence/session-data';

import { EMBEDDED_CONFLUENCE_NAVIGATION_MESSAGE } from './embeddedConfluenceConstants';

export const useIframeNavMessageListener = () => {
	const isIframePreloadingFFEnabled: boolean = useBooleanFeatureFlag(
		'confluence.frontend.embedded-confluence.enable.iframe.preloading',
	);
	const { push } = useRouteActions();
	useEffect(() => {
		if (!isIframePreloadingFFEnabled) {
			return;
		}
		const navigate = (event: MessageEvent) => {
			if (event.data.type === EMBEDDED_CONFLUENCE_NAVIGATION_MESSAGE) {
				push(event.data.url);
			}
		};
		window.addEventListener('message', navigate);
		return () => {
			window.removeEventListener('message', navigate);
		};
	}, [push, isIframePreloadingFFEnabled]);
};
